"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mySegmentsSyncTaskFactory = void 0;
var syncTask_1 = require("../../syncTask");
var mySegmentsFetcher_1 = require("../fetchers/mySegmentsFetcher");
var mySegmentsUpdater_1 = require("../updaters/mySegmentsUpdater");
/**
 * Creates a sync task that periodically executes a `mySegmentsUpdater` task
 */
function mySegmentsSyncTaskFactory(fetchMySegments, storage, readiness, settings, matchingKey) {
    return (0, syncTask_1.syncTaskFactory)(settings.log, (0, mySegmentsUpdater_1.mySegmentsUpdaterFactory)(settings.log, (0, mySegmentsFetcher_1.mySegmentsFetcherFactory)(fetchMySegments), storage.splits, storage.segments, readiness.segments, settings.startup.requestTimeoutBeforeReady, settings.startup.retriesOnFailureBeforeReady, matchingKey), settings.scheduler.segmentsRefreshRate, 'mySegmentsUpdater');
}
exports.mySegmentsSyncTaskFactory = mySegmentsSyncTaskFactory;
